<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1 i18n>New role</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <app-form-default [formData$]="formData$" (submitted)="onSubmit()"></app-form-default>
  </mat-card-content>
</mat-card>
